<template>
  <div class="max-width-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MaxWidthContainer',
}
</script>

<style lang="postcss" scoped>
.max-width-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: calc(
    var(--navigation-max-width) - var(--body-offset-horizontal) -
      var(--body-offset-horizontal)
  );
}

@media (--lg) {
  .max-width-container {
    height: 100%;
    justify-content: space-between;
    margin: auto;
  }
}
</style>
